import React, { FC } from 'react';

import { FlexPaymentRateSectionProps } from './types';
import styles from './styles.module.css';

export const FlexPaymentRateSection: FC<FlexPaymentRateSectionProps> = ({
  labelId,
  label,
  value,
  detail,
  footer,
}) => (
  <section className={styles.section} aria-labelledby={labelId}>
    <dl className={styles.sectionDefinition}>
      <dt id={labelId} className={styles.label}>
        {label}
      </dt>
      <dd className={styles.sectionValue}>{value}</dd>
      {detail && <dd className={styles.sectionDetail}>{detail}</dd>}
    </dl>
    {footer && <div className={styles.sectionFooter}>{footer}</div>}
  </section>
);
